<template>
  <div id="pageRoot">
    <img id="bg" class="pageElement" src="/pages/img/sordoglo/svgGlo20bg.svg" />

    <span class="normalTheme pageInstruction" style="left: 68px; top: 141px">
      <p>Lee los globos.</p>
    </span>
    <span class="normalTheme pageInstruction" style="left: 68px; top: 190px">
      <p>
        Dibuja los animales y escribe<br />
        quién lo dijo.
      </p>
    </span>
    <span class="normalTheme pageInstruction" style="left: 68px; top: 270px">
      <p>Sube fotos de tus dibujos.</p>
    </span>

    <img
      id="globe1"
      class="text-box-a pageElement hover-animation-a"
      src="/pages/img/sordoglo/svgGlo20globes.svg"
    />
    <img
      id="globe2"
      class="text-box-a pageElement hover-animation-a"
      src="/pages/img/sordoglo/svgGlo20globe2.svg"
    />

    <p id="tag01" class="textBase basicItem01 tagDefault">EL PATO</p>
    <p id="tag02" class="textBase basicItem01 tagDefault">EL CARACOL</p>
    <p id="tag03" class="textBase basicItem01 tagDefault">EL CANGREJO</p>
    <p id="tag04" class="textBase basicItem01 tagDefault">EL SAPO</p>

    <uploaded-image
      class="image01 pageElement picture-slot hover-animation-b"
      v-bind:page="$parent.page"
      v-bind:type="$parent.type"
      number="1"
    ></uploaded-image>
    <uploaded-image
      class="image02 pageElement picture-slot hover-animation-b"
      v-bind:page="$parent.page"
      v-bind:type="$parent.type"
      number="1"
    ></uploaded-image>

    <div
      id="button01"
      style="position: absolute; margin-left: 2.5%; margin-top: 65%; z-index: 5"
    >
      <image-upload
        v-bind:page="$parent.page"
        v-bind:type="$parent.type"
        number="1"
        class="pageElement"
      ></image-upload>
    </div>
    <div
      id="button02"
      style="position: absolute; margin-left: 2.5%; margin-top: 65%; z-index: 5"
    >
      <image-upload
        v-bind:page="$parent.page"
        v-bind:type="$parent.type"
        number="2"
        class="pageElement"
      ></image-upload>
    </div>

    <saved-input
      v-bind:page="$parent.page"
      v-bind:type="$parent.type"
      number="1"
      id="inputField01"
      class="pageElement"
    />
    <saved-input
      v-bind:page="$parent.page"
      v-bind:type="$parent.type"
      number="1"
      id="inputField02"
      class="pageElement"
    />
  </div>
</template>
<style scoped>
#bg {
  position: absolute;
  left: 23px;
  top: 40px;
}
#tag01 {
  position: absolute;
  width: 230px;
  text-align: center;
  left: 467px;
  top: 110px;
}
#tag02 {
  position: absolute;
  width: 230px;
  text-align: center;
  left: 737px;
  top: 110px;
}
#tag03 {
  position: absolute;
  width: 230px;
  text-align: center;
  left: 467px;
  top: 200px;
}
#tag04 {
  position: absolute;
  width: 230px;
  text-align: center;
  left: 737px;
  top: 200px;
}
#globe1 {
  position: absolute;
  left: 35px;
  top: 325px;
  z-index: 5;
}
#globe2 {
  position: absolute;
  left: 536px;
  top: 325px;
  z-index: 5;
}
.image01 {
  position: absolute;
  width: 482px;
  height: 309px;
  left: 25px;
  top: 398px;
}
.image02 {
  position: absolute;
  width: 482px;
  height: 309px;
  left: 522px;
  top: 398px;
}
#button01 {
  width: 216px;
  height: 77px;
  left: 280px;
  top: 2px;
}
#button02 {
  width: 216px;
  height: 77px;
  left: 777px;
  top: 2px;
}
#inputField01 {
  position: absolute;
  width: 226px;
  height: 31px;
  left: 38px;
  top: 673px;
  z-index: 5;
}
#inputField02 {
  position: absolute;
  width: 226px;
  height: 31px;
  left: 533px;
  top: 673px;
  z-index: 5;
}
</style>

<script>
import ImageUpload from "../../../components/ImageUpload.vue";
export default {
  name: "App",
  components: {
    ImageUpload,
  },
};
</script>